import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=c06f65d6&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=c06f65d6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06f65d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c06f65d6')) {
      api.createRecord('c06f65d6', component.options)
    } else {
      api.reload('c06f65d6', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=c06f65d6&scoped=true", function () {
      api.rerender('c06f65d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/authentication/ForgotPassword.vue"
export default component.exports